/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_Skin_3_TitleInputs */

const en_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinky Puffs`)
};

const ar_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بينكي بافس`)
};

const de_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinky Puffs`)
};

const es_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copos rosados`)
};

const fr_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coton Bonbon`)
};

const it_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvole rosa`)
};

const ja_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ふわふわピンク`)
};

const ko_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`핑크빛 솜구름`)
};

const pt_br_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manto róseo`)
};

const ru_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розовые облачка`)
};

const th_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปุยสีชมพู`)
};

const tr_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembe Puflar`)
};

const zh_cn_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落樱缤纷`)
};

const zh_tw_land_skin_3_title = /** @type {(inputs: Land_Skin_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落櫻繽紛`)
};

/**
* | output |
* | --- |
* | "Pinky Puffs" |
*
* @param {Land_Skin_3_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land_skin_3_title = /** @type {((inputs?: Land_Skin_3_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_Skin_3_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_skin_3_title(inputs)
	if (locale === "ar") return ar_land_skin_3_title(inputs)
	if (locale === "de") return de_land_skin_3_title(inputs)
	if (locale === "es") return es_land_skin_3_title(inputs)
	if (locale === "fr") return fr_land_skin_3_title(inputs)
	if (locale === "it") return it_land_skin_3_title(inputs)
	if (locale === "ja") return ja_land_skin_3_title(inputs)
	if (locale === "ko") return ko_land_skin_3_title(inputs)
	if (locale === "pt_br") return pt_br_land_skin_3_title(inputs)
	if (locale === "ru") return ru_land_skin_3_title(inputs)
	if (locale === "th") return th_land_skin_3_title(inputs)
	if (locale === "tr") return tr_land_skin_3_title(inputs)
	if (locale === "zh_cn") return zh_cn_land_skin_3_title(inputs)
	return zh_tw_land_skin_3_title(inputs)
});